/* ALEVA favorites: shared with the existing product-detail wishlist. */
(() => {
  'use strict';
  const KEY = 'aleva-wishlist-products';
  const idValid = (value) => /^\d{6,20}$/.test(String(value));
  function read() {
    try {
      const value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? [...new Set(value.map(String).filter(idValid))].slice(0, 500) : [];
    } catch (_) { return []; }
  }
  function save(ids) {
    try {
      localStorage.setItem(KEY, JSON.stringify(ids));
      return true;
    } catch (_) { return false; }
  }
  const labels = {
    de: { add:'Zu Favoriten hinzufügen', remove:'Aus Favoriten entfernen', open:'Duft ansehen', account:'Im ALEVA Konto speichern', missing:'Dieser Duft ist derzeit nicht verfügbar', empty:'Du hast noch keine Düfte gespeichert.' },
    en: { add:'Add to favorites', remove:'Remove from favorites', open:'View fragrance', account:'Save in ALEVA account', missing:'This fragrance is currently unavailable', empty:'You have not saved any fragrances yet.' },
    ar: { add:'إضافة إلى المفضلة', remove:'إزالة من المفضلة', open:'عرض العطر', account:'حفظ في حساب ALEVA', missing:'هذا العطر غير متوفر حاليا', empty:'لم تحفظ أي عطور بعد' }
  };
  function accountUrl(action, value) {
    const config = document.getElementById('AlevaFavoritesBridgeConfig');
    if (!config) return null;
    try {
      const url = new URL(JSON.parse(config.textContent), window.location.href);
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
      if (action && value) url.searchParams.set(action, value);
      return url.href;
    } catch (_) { return null; }
  }
  function language() {
    const key = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
    return labels[key] ? key : 'de';
  }
  function refresh() {
    const ids = read();
    const selected = new Set(ids);
    document.querySelectorAll('[data-aleva-wishlist-count]').forEach((el) => {
      // These counts are account-scoped, not known from localStorage.
      el.textContent = '';
      el.hidden = true;
    });
    document.querySelectorAll('.aleva-fav-remove[data-aleva-wishlist-button]').forEach((button) => {
      const active = selected.has(String(button.dataset.alevaWishlistId));
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      const l = labels[language()];
      button.setAttribute('aria-label', active ? l.remove : l.add);
      button.title = active ? l.remove : l.add;
    });
    document.querySelectorAll('[data-aleva-wishlist-button]:not(.aleva-fav-remove)').forEach(button => {
      button.classList.remove('is-active');
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-label', labels[language()].account);
      button.title = labels[language()].account;
    });
    const pdp = document.getElementById('pdpWishlist');
    const product = document.querySelector('[data-aleva-product]');
    if (pdp && product) {
      pdp.classList.remove('is-active');
      pdp.setAttribute('aria-pressed', 'false');
      pdp.setAttribute('aria-label', labels[language()].account);
    }
    render(ids);
  }
  function render(ids) {
    const page = document.querySelector('[data-aleva-wishlist-page]');
    if (!page) return;
    const openLink=page.querySelector('[data-aleva-open-account-link]');
    const importLink=page.querySelector('[data-aleva-import-link]');
    if(openLink){
      const u=accountUrl();
      if(u){openLink.href=u;openLink.hidden=false;}
    }
    if(importLink){
      const u=ids.length?accountUrl('aleva_import',ids.slice(0,100).join(',')):null;
      if(u){importLink.href=u;importLink.hidden=false;}else importLink.hidden=true;
    }
    const list = page.querySelector('[data-aleva-wishlist-list]');
    const empty = page.querySelector('[data-aleva-wishlist-empty]');
    if (!list || !empty) return;
    let products = [];
    try { products = JSON.parse(document.getElementById('AlevaWishlistCatalog').textContent); }
    catch (_) { /* No catalog. Saved entries remain removable. */ }
    const byId = new Map((Array.isArray(products) ? products : []).map((p) => [String(p.id), p]));
    list.replaceChildren();
    empty.hidden = ids.length !== 0;
    if (!ids.length) return;
    const l = labels[language()];
    ids.forEach((id) => {
      const p = byId.get(id);
      const article = document.createElement('article');
      article.className = 'aleva-fav-card';
      if (p) {
        const link = document.createElement('a');
        link.className = 'aleva-fav-image';
        link.href = p.url;
        if (p.image) {
          const img = document.createElement('img');
          img.src = p.image;
          img.alt = p.title;
          img.loading = 'lazy';
          img.decoding = 'async';
          img.width = 460;
          link.append(img);
        } else {
          const placeholder = document.createElement('span');
          placeholder.textContent = 'ALEVA';
          link.append(placeholder);
        }
        article.append(link);
      }
      const content = document.createElement('div');
      content.className = 'aleva-fav-content';
      const brand = document.createElement('span');
      brand.className = 'aleva-fav-eyebrow';
      brand.textContent = p ? (p.vendor || 'ALEVA') : 'ALEVA';
      content.append(brand);
      const title = document.createElement(p ? 'a' : 'p');
      title.className = 'aleva-fav-title';
      title.textContent = p ? p.title : l.missing;
      if (p) title.href = p.url;
      content.append(title);
      if (p) {
        const price = document.createElement('span');
        price.className = 'aleva-fav-price';
        price.textContent = p.price;
        content.append(price);
        const visit = document.createElement('a');
        visit.className = 'aleva-fav-visit';
        visit.href = p.url;
        visit.textContent = l.open;
        content.append(visit);
      }
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'aleva-fav-remove';
      remove.dataset.alevaWishlistButton = '';
      remove.dataset.alevaWishlistId = id;
      remove.setAttribute('aria-label', l.remove);
      remove.textContent = '×';
      content.append(remove);
      article.append(content);
      list.append(article);
    });
  }
  // Capture before the legacy product-page localStorage click handler.
  window.addEventListener('click', (event) => {
    const origin = event.target;
    if (!(origin instanceof Element)) return;
    const legacyRemove = origin.closest('.aleva-fav-remove[data-aleva-wishlist-button]');
    if (legacyRemove) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const id=String(legacyRemove.dataset.alevaWishlistId||'');
      if (!idValid(id)) return;
      const next=read().filter(saved => saved!==id);
      if(save(next))refresh();
      return;
    }
    const card = origin.closest('[data-aleva-wishlist-button]');
    const pdp = origin.closest('#pdpWishlist');
    if (!card && !pdp) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const product = document.querySelector('[data-aleva-product]');
    const id=card ? String(card.dataset.alevaWishlistId||'') : String(product?.dataset.productId||'');
    if(!idValid(id))return;
    const target=accountUrl('aleva_add',id);
    if(target) window.location.assign(target);
  }, true);
  document.addEventListener('DOMContentLoaded', refresh);
  window.addEventListener('pageshow', refresh);
  window.addEventListener('storage', (event) => { if (event.key === KEY) refresh(); });
  document.addEventListener('aleva:languagechange', refresh);
})();
